// extracted by mini-css-extract-plugin
export default {"textAreaBox":"customeTextArea_styles_textAreaBox__XO6xC"};